import React, { useContext } from 'react';

import { Breadcrumbs } from '../../../components/Breadcrumbs';
import { Settings } from '../../../components/Settings';
import { ContentContext } from '../../../context/ContentContext';

export const DocumentationSettings: React.FC = () => {
  const { displayedValues } = useContext(ContentContext);

  return displayedValues.length ? <Settings /> : <Breadcrumbs />;
};
